import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon } from '@heroicons/react/solid';

const NavBar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <header className="container text-white-default mx-auto p-4 flex flex-col lg:flex-row justify-between items-center">
            <div className="flex justify-between items-center w-full lg:w-auto">
                <h1 className="text-3xl font-extrabold">LogBug</h1>
                <button onClick={toggleMenu} className="text-gray-400 hover:text-white transition lg:hidden ml-4" aria-label="Toggle Menu">
                    {menuOpen ? (
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    ) : (
                        <MenuIcon className="w-6 h-6" />
                    )}
                </button>
            </div>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex space-x-10 mx-auto">
                <Link to="/dashboard" className="text-gray-400 hover:text-white transition">Dashboard</Link>
                <Link to="/organizations" className="text-gray-400 hover:text-white transition">Organizations</Link>
            </nav>

            <div className="hidden lg:block">
                <Link to="/logout" className="px-4 py-2 border border-gray-400 text-gray-400 hover:bg-gray-600 hover:text-white transition rounded-md">Logout</Link>
            </div>

            {/* Mobile Menu (Appears only when menuOpen is true) */}
            {menuOpen && (
                <nav className="lg:hidden flex flex-col w-screen mt-4 space-y-4 bg-dark-200 p-4 rounded-lg">
                    <Link to="/dashboard" className="text-gray-400 hover:text-white transition" onClick={toggleMenu}>Dashboard</Link>
                    <Link to="/organizations" className="text-gray-400 hover:text-white transition" onClick={toggleMenu}>Organizations</Link>
                    <Link to="/logout"  className="w-full px-4 py-2 border border-gray-400 text-gray-400 hover:bg-gray-600 hover:text-white transition rounded-md">Logout</Link>
                </nav>
            )}
        </header>
    );
};

export default NavBar;
